import { apiClient } from "../../Service";
const getNavigationInfo = async () => {
    const client = apiClient("default");
    return await client
        .post("ajax?ajax=get_navigation_info")
        .then((response) => {
        return {
            isLoggedIn: !!response.is_logged_in,
        };
    });
};
export { getNavigationInfo };
